import React from 'react'

const FLOTA_TECNICA = 'Flota Técnica';
const FLOTA_COLABORADOR = 'Flota Colaboradores';
const PARTICULAR = 'Particular';

export default function AffiliationTypeCheckboxList({
    affiliationType,
    handleAffiliationTypeChange,
    error,
    clearErrorByFiueldName
}) {
  return (
    <>
        <label className="surcharges-form__label">Tipo de afiliación *</label>
          <div className="surcharges-form__radio-group">
            <label className={`surcharges-form__radio-card ${affiliationType.includes(PARTICULAR) ? 'surcharges-form__radio-card--active' : ''}`}>
              <input 
                type="checkbox" 
                name="affiliationType" 
                value="particular" 
                checked={affiliationType.includes(PARTICULAR)}
                onChange={() => { handleAffiliationTypeChange(PARTICULAR); clearErrorByFiueldName('contractTypes'); }}
              />
              <div className="surcharges-form__radio-text">
                <span className="surcharges-form__radio-title">Particular</span>
                <span className="surcharges-form__radio-subtitle">Clientes individuales</span>
              </div>
            </label>

            <label className={`surcharges-form__radio-card ${affiliationType.includes(FLOTA_TECNICA) ? 'surcharges-form__radio-card--active' : ''}`}>
              <input 
                type="checkbox" 
                name="affiliationType" 
                value="flota_tecnica" 
                checked={affiliationType.includes(FLOTA_TECNICA)}
                onChange={() => { handleAffiliationTypeChange(FLOTA_TECNICA); clearErrorByFiueldName('contractTypes'); }}
              />
              <div className="surcharges-form__radio-text">
                <span className="surcharges-form__radio-title" style={{ color: affiliationType.includes(FLOTA_TECNICA) ? '#005ce6' : '' }}>Flota</span>
                <span className="surcharges-form__radio-subtitle">Flotas técnicas</span>
              </div>
            </label>

            <label className={`surcharges-form__radio-card ${affiliationType.includes(FLOTA_COLABORADOR) ? 'surcharges-form__radio-card--active' : ''}`}>
              <input 
                type="checkbox" 
                name="affiliationType" 
                value="flota_colaboradores" 
                checked={affiliationType.includes(FLOTA_COLABORADOR)}
                onChange={() => { handleAffiliationTypeChange(FLOTA_COLABORADOR); clearErrorByFiueldName('contractTypes'); }}
              />
              <div className="surcharges-form__radio-text">
                <span className="surcharges-form__radio-title">Flota</span>
                <span className="surcharges-form__radio-subtitle">Flotas colaborador</span>
              </div>
            </label>
          </div>
          {error && (<p className="surcharges-form__error-message">Debe Seleccionar al menos un tipo de afiliación</p>)}
          
    </>
  )
}
